/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Input, Tooltip, Spin, BackTop } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import likeliHoodImpact from '../../../assets/Images/svg/likeliHood/likelihood-impact-img.svg';
import { useBlocker } from '../../../util/usePrompt';
import { useNavigate, useParams } from 'react-router-dom';
import useNotify from '../../../context/Notification/useNotify';
import ModalDiscardChanges from '../../../components/Shared/modal/discardChanges';
import ModalConfirm from '../../../components/Shared/modal/confirm';
import RiskAssessmentService from '../../../services/RiskAssessment.service';
import { ROUTER } from '../../../constants/router';

export default function Tab3({ detail, mode, getRiskAssessment, lastUpdate }) {
    const { t, i18n } = useTranslation();
    const { riskId } = useParams();
    const lang = i18n.language;
    const [form] = Form.useForm();
    const { TextArea } = Input;
    const [likelihoodMaster, setLikelihoodMaster] = useState([]);
    const [definitionsMaster, setDefinitionsMaster] = useState([]);
    const [loadingForm, setLoadingForm] = useState(false);

    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);
    const [fields, setFields] = useState([]);

    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);
    const Navigate = useNavigate();
    const notify = useNotify();

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };
    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        setOpenChange(false);
        setChange(false);
        setIsChangeLocation(false);
        await form.resetFields();
        await Navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
        await getLikelihood();
        await getRiskAssessment();
    };
    const changePage = () => {
        Navigate(`${ROUTER.RISK_MANAGEMENT.RA}/${riskId}/view?tab=3`);
        form.resetFields();
    };

    const getLevelColor = (id) => {
        switch (id) {
            case '4a63f6a407f611ed8bf4fa163e89e3c8':
                return { color: '#FFF', background: '#A7D17E' };
            case '5fead50b07f611ed8bf4fa163e89e3c8':
                return { color: '#FFF', background: '#FFD15C' };
            case '749e117407f611ed8bf4fa163e89e3c8':
                return { color: '#FFF', background: '#EA8A54' };
            case 'a64aa37007f611ed8bf4fa163e89e3c8':
                return { color: '#FFF', background: '#CD5D4A' };
            case 'b5c52f8307f611ed8bf4fa163e89e3c8':
                return { color: '#FFF', background: '#A3402F' };
            default:
                return { color: '#FFF', background: '' };
        }
    };

    // Confirm
    const [openConfirm, setOpenConfirm] = useState(false);
    const [valueSave, setValueSave] = useState();
    const [loading, setLoading] = useState(false);

    const onSubmit = async () => {
        const likelihood = [];
        for (const item in likelihoodMaster) {
            let optionItem = [];
            for (const i in likelihoodMaster[item].likelihoodLevels) {
                optionItem.push({
                    likelihoodLevelId:
                        likelihoodMaster[item].likelihoodLevels[i]
                            .mLikelihoodLevelId,
                    likelihoodLevelName:
                        valueSave[
                            likelihoodMaster[item].likelihoodLevels[i]
                                .mRiskLevelPlanId
                        ],
                    mRiskLevelPlanId:
                        likelihoodMaster[item].likelihoodLevels[i]
                            .mRiskLevelPlanId,
                    seq: likelihoodMaster[item].likelihoodLevels[i].seq,
                });
            }
            likelihood.push({
                likelihoodLevels: optionItem,
                likelihoodTopicId: likelihoodMaster[item].mLikelihoodTopicId,
                likelihoodTopicNameEn:
                    likelihoodMaster[item].mLikelihoodTopicNameEn,
                likelihoodTopicNameTh:
                    likelihoodMaster[item].mLikelihoodTopicNameTh,
                seq: likelihoodMaster[item].seq,
            });
        }
        if (mode === 'create') {
            try {
                const { data } = await RiskAssessmentService.createLikelihood({
                    likelihood: likelihood,
                });
                if (data?.resultCode === 1) {
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully save data'),
                    });
                    setOpenChange(false);
                    setChange(false);
                    setLoading(false);
                    setOpenConfirm(false);
                    Navigate(
                        `${ROUTER.RISK_MANAGEMENT.RA}/${riskId}/view?tab=3`
                    );
                } else {
                    setOpenConfirm(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to save data'),
                    });
                }
            } catch (error) {
                console.log(error);
                setOpenConfirm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to save data'),
                });
            }
        } else {
            try {
                const { data } = await RiskAssessmentService.updateLikelihood({
                    likelihood: likelihood,
                });
                if (data?.resultCode === 1) {
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully save data'),
                    });
                    setOpenChange(false);
                    setChange(false);
                    setLoading(false);
                    setOpenConfirm(false);
                    Navigate(
                        `${ROUTER.RISK_MANAGEMENT.RA}/${riskId}/view?tab=3`
                    );
                } else {
                    setOpenConfirm(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to save data'),
                    });
                }
            } catch (error) {
                console.log(error);
                setOpenConfirm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to save data'),
                });
            }
        }
    };

    const getDefinitions = async () => {
        const { data } = await RiskAssessmentService.getDefinitions();
        if (data.resultData) {
            setDefinitionsMaster(data.resultData);
        }
    };
    const getLikelihood = async () => {
        const { data } = await RiskAssessmentService.getLikelihood();
        if (data.resultData) {
            setLikelihoodMaster(data.resultData.likelihood);
            const items = data.resultData.likelihood;
            if (!detail.length) {
                await items?.forEach((element) => {
                    element.likelihoodLevels?.forEach((i) => {
                        setFields([
                            {
                                name: [`${i.mRiskLevelPlanId}`],
                                value: `${i.mLikelihoodLevelName}`,
                            },
                        ]);
                    });
                });
            }
            await setFieldsDetail();
        }
    };
    useEffect(() => {
        setLoadingForm(true);
        getDefinitions();
        getLikelihood();
    }, [detail]);

    const setFieldsDetail = async () => {
        if (detail) {
            detail?.forEach((element) => {
                element.likelihoodLevels?.forEach((i) => {
                    setFields([
                        {
                            name: [`${i.mriskLevelPlanId}`],
                            value: `${i.likelihoodLevelName}`,
                        },
                    ]);
                });
            });
            setLoadingForm(false);
        }
    };
    return (
        <>
            <Spin spinning={loadingForm}>
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    layout="vertical"
                    form={form}
                    fields={fields}
                    onFinish={(value) => {
                        setOpenConfirm(true);
                        setValueSave(value);
                    }}
                    onFinishFailed={(value) => {
                        console.log('value failed ', value);
                    }}
                    onFieldsChange={(_, allFields) => {
                        if (allFields.length > 0) {
                            setChange(true);
                        }
                    }}
                    // initialValues={{ }}
                >
                    <div className="p-4">
                        {/* <<<<<< Header >>>>>> */}
                        <div
                            className="mb-4"
                            style={{ borderBottom: '3px solid #F4F6FC' }}
                        >
                            <div className="flex justify-between">
                                <div className="flex space-x-2 items-center pb-2">
                                    <div className="text-2xl font-bold pb-1">
                                        {t('RA.Likelihood')}
                                    </div>
                                    <Tooltip
                                        overlayStyle={{
                                            minWidth: '18%',
                                        }}
                                        placement="rightTop"
                                        title={t('Tooltip.Likelihood')}
                                    >
                                        <a className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm">
                                            <ExclamationCircleOutlined />
                                        </a>
                                    </Tooltip>
                                </div>
                                <div className="flex space-x-4 items-center">
                                    <Button
                                        size="large"
                                        type="default"
                                        className="text-purple-PHX border-purple-PHX w-32"
                                        onClick={changePage}
                                    >
                                        {t('common.Cancel')}
                                    </Button>
                                    <Button
                                        size="large"
                                        type="primary"
                                        className="w-32"
                                        htmlType="submit"
                                    >
                                        {t('common.Save')}
                                    </Button>
                                </div>
                            </div>

                            <div className="pb-6 flex items-center">
                                <div className="font-bold">
                                    {t('Last Update')} :{' '}
                                </div>
                                <div className="ml-1">
                                    {lastUpdate?.likelihoodUpdateDate || '-'}
                                    {/* {lastUpdate?.likelihoodUpdateDate ? moment(new Date(lastUpdate?.likelihoodUpdateDate)).format('DD/MM/YYYY HH:mm') : '-'} */}
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-3">
                            <div className="col-span-2 my-1 mr-4">
                                <div className="p-4 box-content">
                                    {likelihoodMaster?.map((is) => (
                                        <>
                                            <div className="text-base font-semibold">
                                                {lang === 'en'
                                                    ? is.mLikelihoodTopicNameEn
                                                    : is.mLikelihoodTopicNameTh}
                                            </div>
                                            {is.likelihoodLevels?.map(
                                                (item) => (
                                                    <div
                                                        key={
                                                            item.mRiskLevelPlanId
                                                        }
                                                        className="pl-5 relative mb-4 mt-2"
                                                    >
                                                        <Form.Item
                                                            className="mb-0"
                                                            name={`${item.mRiskLevelPlanId}`}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: t(
                                                                        'errorText.requiredField'
                                                                    ),
                                                                },
                                                            ]}
                                                        >
                                                            <TextArea
                                                                className="pr-12 bg-white"
                                                                autoSize={{
                                                                    minRows: 2,
                                                                    maxRows: 2,
                                                                }}
                                                                placeholder={t(
                                                                    'RA.RiskLevelpl'
                                                                )}
                                                            />
                                                        </Form.Item>
                                                        <div
                                                            className={`absolute px-0 py-0 absolute top-0 left-0 text-[${
                                                                getLevelColor(
                                                                    item.mRiskLevelPlanId
                                                                ).background
                                                            }] text-4xl align-middle`}
                                                        >
                                                            &#8226;
                                                        </div>{' '}
                                                    </div>
                                                )
                                            )}
                                        </>
                                    ))}
                                </div>
                            </div>
                            <div className="table-risk-custom">
                                <img
                                    // className="icon-zoom"
                                    src={likeliHoodImpact}
                                    alt="LikeliHood Impact"
                                    // onClick={() => }
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-1 mt-4">
                            <div className="col-span-2 mb-2 table-risk-custom">
                                <table
                                    style={{
                                        width: '100%',
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            <th colSpan={2}>
                                                {t('RA.Definition')}
                                            </th>
                                            <th>{t('RA.Guidelines')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {definitionsMaster?.map((e) => (
                                            <tr key={e.levelId}>
                                                <td
                                                    style={{
                                                        background: `${
                                                            getLevelColor(
                                                                e.levelId
                                                            ).background
                                                        }`,
                                                        color: `${
                                                            getLevelColor(
                                                                e.levelId
                                                            ).color
                                                        }`,
                                                        fontWeight: '600',
                                                        textAlign: 'center',
                                                        border: 'none',
                                                    }}
                                                >
                                                    {lang === 'en'
                                                        ? e.levelEn
                                                        : e.levelTh}
                                                </td>
                                                <td>
                                                    {lang === 'en'
                                                        ? e.levelNameEn
                                                        : e.levelNameTh}
                                                </td>
                                                <td>
                                                    {lang === 'en'
                                                        ? e.descriptionEn
                                                        : e.descriptionTh}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
            <BackTop>
                <div style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
            <ModalConfirm
                loading={loading}
                text={t('Do you want to confirm')}
                open={openConfirm}
                handelOk={onSubmit}
                handelClose={() => setOpenConfirm(false)}
            />
        </>
    );
}
const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
